import React, { useState } from "react";

export default function Asthapna() {
  const [tab, setTab] = useState("prastavana");

  const tabs = {
    prastavana: "प्रस्तावना",
    rachana: "रचना",
    pad: "पदांचा तपशील",
    sampark: "संपर्क",
  };

  const tabStyle = (t) => ({
    padding: "10px 20px",
    cursor: "pointer",
    borderBottom: tab === t ? "3px solid #3949AB" : "2px solid transparent",
    fontWeight: tab === t ? "700" : "500",
  });

  return (
    <div style={{ padding: "20px", background: "#f5f5f5" }}>
      {/* PAGE TITLE */}
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <img
          src="/images/department_icon.png"
          alt="dept"
          style={{ width: "70px", height: "70px" }}
        />
        <h1 style={{ fontSize: "30px", color: "#1A237E" }}>आस्थापना विभाग</h1>
      </div>

      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "25px",
          background: "white",
          padding: "10px",
          borderRadius: "10px",
        }}
      >
        {Object.keys(tabs).map((key) => (
          <div key={key} style={tabStyle(key)} onClick={() => setTab(key)}>
            {tabs[key]}
          </div>
        ))}
      </div>

      {/* CONTENT BOX */}
      <div
        style={{
          marginTop: "20px",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
          lineHeight: "1.7",
        }}
      >
        {tab === "prastavana" && (
          <>
            <h2 style={{ fontSize: "22px", marginBottom: "10px" }}>
              विभागाची प्रस्तावना
            </h2>

            <p>
              सामान्य प्रशासन विभाग हा पंचायत समितीचा महत्वाचा विभाग असून
              पंचायत समितीतील सर्व विभागांच्या प्रशासकीय नियंत्रण ठेवून
              कार्यालयाची सर्वसंभाळ करणारा विभाग आहे.
            </p>

            <p>
              विकास अधिकारी व इतर विभागांबरोबर समन्वय साधून कामकाज पाहिल्या
              जाते.
            </p>
          </>
        )}

        {tab === "rachana" && (
          <p>येथे विभागाची रचना दाखवली जाईल…</p>
        )}

        {tab === "pad" && (
          <p>येथे पदांची यादी दाखवली जाईल…</p>
        )}

        {tab === "sampark" && (
          <p>संपर्क माहिती येथे दिसेल…</p>
        )}
      </div>
    </div>
  );
}
